var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.656,
    height: 110.43,
    viewBox: "0 0 105.656 110.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#53b8a9}.cls-3{fill:#e5e8d4}.cls-4{fill:#898998}.cls-5{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    transform: "translate(-583.964 -1084.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    transform: "translate(-3.203 298.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    transform: "rotate(81 -127.37 796.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    fill: "#efefef",
    d: "M70.365 10.212c-18.588 0-31.352-9.628-40.308-9.628S2.29 5.733 2.29 46.935s25.31 47.25 35.157 47.25c46.131.002 65.836-83.973 32.918-83.973z",
    transform: "translate(-2.29 -.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "team",
    transform: "translate(597 785.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    d: "M91.2 329.723l-6-1.439-6.04 1.443a10.109 10.109 0 0 0-7.76 9.832v11.4h5.01l19.712-18.419a10.085 10.085 0 0 0-4.922-2.817z",
    className: "cls-2",
    transform: "translate(-59.289 -272.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    d: "M109.93 230.1a9.5 9.5 0 0 0 6.3-8.944v-5.9h-12.6v5.9a9.5 9.5 0 0 0 6.3 8.944z",
    className: "cls-3",
    transform: "translate(-86.056 -178.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    d: "M104.456 173.04h.017a22.643 22.643 0 0 0 11.638-3.22l.809 3.22v-2.286a9.5 9.5 0 0 0-5.428-8.582 11.547 11.547 0 0 0-7.035 10.63z",
    className: "cls-4",
    transform: "translate(-86.743 -134.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    d: "M371.827 307.728l-6.959-1.662v-4.273h-8.52v4.259l-1.758.421 5.252 1.255a10.109 10.109 0 0 1 7.76 9.832v11.4h11.984v-11.4a10.109 10.109 0 0 0-7.759-9.832z",
    className: "cls-2",
    transform: "translate(-294.461 -250.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    d: "M126.111 354.728l7.94-1.9-1.7-.407-11.871-.021-9.718 2.329a14.08 14.08 0 0 0-10.8 13.692v9.347h15.349v-9.348a14.08 14.08 0 0 1 10.8-13.692z",
    className: "cls-5",
    transform: "translate(-83.012 -292.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    d: "M217.2 356.819l-7.988-1.908-7.94 1.9a14.08 14.08 0 0 0-10.8 13.692v9.346h37.536v-9.338a14.08 14.08 0 0 0-10.808-13.692z",
    className: "cls-2",
    transform: "translate(-158.176 -294.725)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    transform: "translate(16.279 51.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    d: "M100.155 301.793H96v4.389l4.417 10.575 2.077-4.975-2.339-5.6z",
    className: "cls-5",
    transform: "translate(-96 -301.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    d: "M368.035 301.793h-4.155v4.374l4.421 10.591 2.078-4.975-2.345-5.616z",
    className: "cls-5",
    transform: "translate(-318.455 -301.793)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    transform: "translate(20.433 51.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    d: "M125.184 301.793H120.5v4.389l2.339 5.6 2.345-5.616z",
    className: "cls-3",
    transform: "translate(-120.5 -301.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    d: "M393.064 301.793h-4.684v4.374l2.344 5.616 2.339-5.6z",
    className: "cls-3",
    transform: "translate(-342.955 -301.793)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    d: "M224.581 325.473v-1.381h-5.172v1.381a5.222 5.222 0 0 1-.735 2.674l6.331 14.368 2.585-5.87-3.745-8.5a5.222 5.222 0 0 0 .736-2.672z",
    className: "cls-5",
    transform: "translate(-181.593 -269.132)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    transform: "translate(39.171 32.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    d: "M255.923 325.473v-1.381h-6.014v1.381a5.222 5.222 0 0 1-.735 2.674l3.745 8.5 3.741-8.494a5.223 5.223 0 0 1-.737-2.68z",
    className: "cls-3",
    transform: "translate(-246.092 -301.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    d: "M239.733 213.09a13.231 13.231 0 0 0 8.733-12.443v-9.126H231v9.126a13.231 13.231 0 0 0 8.733 12.443z",
    className: "cls-3",
    transform: "translate(-231 -191.521)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    d: "M240.641 122.237A15.525 15.525 0 0 0 231 136.6v.669a14.531 14.531 0 0 0 8.618-4.977l8.61 5.059.238-.167v-2.874a13.227 13.227 0 0 0-7.825-12.073z",
    className: "cls-4",
    transform: "translate(-191.829 -101.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    d: "M378.546 230.084a9.5 9.5 0 0 0 6.253-8.927v-5.9h-12.506v5.9a9.5 9.5 0 0 0 6.253 8.927z",
    className: "cls-3",
    transform: "translate(-309.162 -178.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    d: "M379.9 162.568a11.912 11.912 0 0 0-7.135 10.022q.426.115.857.212l.12-.477c.448.269.9.521 1.366.764a22.635 22.635 0 0 0 3.538.281h6.546v-2.286a9.495 9.495 0 0 0-5.292-8.516z",
    className: "cls-4",
    transform: "translate(-309.556 -134.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    d: "M1.7 167.591h13.56v5.087a1.7 1.7 0 0 0 1.7 1.7h18.6a1.7 1.7 0 0 0 0-3.391h-7.57v-7.463a1.7 1.7 0 0 0-3.391 0v7.463h-5.952v-7.651a12.346 12.346 0 0 1 9.5-12.043l8.34-2 5.365 12.207a1.7 1.7 0 0 0 1.552 1.013 1.7 1.7 0 0 0 1.552-1.013l5.361-12.191 8.316 1.987a12.344 12.344 0 0 1 9.507 12.044v1.892a1.7 1.7 0 0 0 0 1.326v4.424h-5.911v-7.463a1.7 1.7 0 1 0-3.391 0v7.463h-8.3a1.7 1.7 0 1 0 0 3.391h19.3a1.7 1.7 0 0 0 1.7-1.7v-5.087h13.587a1.7 1.7 0 0 0 1.7-1.7V154.5a11.766 11.766 0 0 0-9.062-11.481l-5.663-1.355v-2.244a11.191 11.191 0 0 0 5.231-9.465v-6.319a11.185 11.185 0 0 0-19.566-7.415 14.949 14.949 0 0 0-14.34-10.789 14.949 14.949 0 0 0-14.346 10.818 11.185 11.185 0 0 0-19.591 7.385v6.319a11.191 11.191 0 0 0 5.231 9.465v2.244l-5.657 1.351A11.767 11.767 0 0 0 0 154.5v11.4a1.7 1.7 0 0 0 1.7 1.691zm28.439-31.658a15.03 15.03 0 0 0 5.637 6.028v2.5a11.774 11.774 0 0 0-3.466-1.445l-5.676-1.36v-2.224a11.272 11.272 0 0 0 3.5-3.499zm30.057 3.494v2.224l-5.676 1.36a11.777 11.777 0 0 0-3.485 1.457v-2.476a15.029 15.029 0 0 0 5.676-6.03 11.279 11.279 0 0 0 3.48 3.465zm-5.242-13.506v3.633a11.53 11.53 0 0 1-23.053-.4v-3.922h4.771a16.184 16.184 0 0 0 11.457-4.732l6.82 4.007v1.418zM27.355 147.99a15.942 15.942 0 0 0-2.867.986l1.652-3.955 5.376 1.288a8.4 8.4 0 0 1 1.217.392zM43.4 156.6l-4.241-9.648v-3.5a14.934 14.934 0 0 0 8.475.016v3.5zm10.654-9.888a8.421 8.421 0 0 1 1.248-.405l5.363-1.285L62.327 149a15.942 15.942 0 0 0-2.906-1zM83.43 154.5v9.7h-3.392v-7.534a1.7 1.7 0 0 0-3.391 0v7.534h-5.116v-.86a15.741 15.741 0 0 0-3.467-9.887l3.519-8.426 5.388 1.287a8.386 8.386 0 0 1 6.459 8.186zm-14.715-11.4l-2.589 6.2-2.554-6.118a1.694 1.694 0 0 0 .012-.186v-2.141a11.115 11.115 0 0 0 5.128 0V143c-.001.033.001.063.003.094zm-2.574-5.339a7.809 7.809 0 0 1-7.8-7.8v-.277c.006-.173.01-.347.01-.521v-4.038a24.344 24.344 0 0 0 10.741 2.5h4.85v2.338a7.81 7.81 0 0 1-7.801 7.792zm0-21.92a7.809 7.809 0 0 1 7.8 7.8v.59h-4.85a20.952 20.952 0 0 1-10.437-2.785 7.815 7.815 0 0 1 7.487-5.611zM31.9 120.355a11.531 11.531 0 0 1 23.063 0v.221l-6.294-3.7a1.7 1.7 0 0 0-2.159.373 12.806 12.806 0 0 1-9.839 4.592H31.9v-1.488zm-19.017 3.281a7.8 7.8 0 0 1 15.287-2.195 20.953 20.953 0 0 1-10.437 2.785h-4.85v-.59zm0 3.982h4.85a24.343 24.343 0 0 0 10.751-2.5v4.841a7.8 7.8 0 0 1-15.6 0l-.005-2.342zm7.8 13.53a11.184 11.184 0 0 0 2.559-.3V142.995c0 .053.005.106.01.16l-2.566 6.143-2.586-6.174c0-.041.005-.081.005-.122v-2.157a11.174 11.174 0 0 0 2.575.302zM3.391 154.5a8.386 8.386 0 0 1 6.459-8.183l5.375-1.284 3.508 8.4a15.741 15.741 0 0 0-3.478 9.9v.868h-5.081v-7.534a1.7 1.7 0 0 0-3.391 0v7.533H3.391z",
    transform: "translate(0 -87.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    d: "M398.316 57.387h1.163a1.7 1.7 0 1 0 0-3.391h-1.163a1.7 1.7 0 0 0 0 3.391z",
    transform: "translate(-329.364 -44.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    d: "M446.837 57.387H448A1.7 1.7 0 1 0 448 54h-1.163a1.7 1.7 0 1 0 0 3.391z",
    transform: "translate(-369.657 -44.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    d: "M426.007 79.382a1.7 1.7 0 0 0 1.7-1.7v-1.159a1.7 1.7 0 1 0-3.391 0v1.163a1.7 1.7 0 0 0 1.691 1.696z",
    transform: "translate(-352.36 -62.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    d: "M426.007 30.862a1.7 1.7 0 0 0 1.7-1.7V28a1.7 1.7 0 1 0-3.391 0v1.163a1.7 1.7 0 0 0 1.691 1.699z",
    transform: "translate(-352.36 -21.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    d: "M41.14 57.387h1.16a1.7 1.7 0 1 0 0-3.387h-1.16a1.7 1.7 0 0 0 0 3.391z",
    transform: "translate(-32.755 -44.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    d: "M89.661 57.387h1.163a1.7 1.7 0 1 0 0-3.391h-1.163a1.7 1.7 0 1 0 0 3.391z",
    transform: "translate(-73.049 -44.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    d: "M68.83 79.382a1.7 1.7 0 0 0 1.7-1.7v-1.159a1.7 1.7 0 0 0-3.391 0v1.163a1.7 1.7 0 0 0 1.691 1.696z",
    transform: "translate(-55.75 -62.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    d: "M68.83 30.862a1.7 1.7 0 0 0 1.7-1.7V28a1.7 1.7 0 1 0-3.391 0v1.163a1.7 1.7 0 0 0 1.691 1.699z",
    transform: "translate(-55.75 -21.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    d: "M247.7 45.937a1.7 1.7 0 0 0 1.7-1.7V39.78a1.7 1.7 0 1 0-3.391 0v4.461a1.7 1.7 0 0 0 1.691 1.696z",
    transform: "translate(-204.285 -31.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    d: "M246.131 2.348a1.732 1.732 0 0 0 .156.292 1.646 1.646 0 0 0 .468.468 1.672 1.672 0 0 0 .293.156 1.712 1.712 0 0 0 .317.1 1.67 1.67 0 0 0 .331.034 1.708 1.708 0 0 0 1.2-.5 1.614 1.614 0 0 0 .21-.258 1.721 1.721 0 0 0 .156-.292 1.642 1.642 0 0 0 .1-.319 1.628 1.628 0 0 0 0-.661 1.591 1.591 0 0 0-.1-.317 1.674 1.674 0 0 0-.162-.294 1.614 1.614 0 0 0-.21-.258 1.707 1.707 0 0 0-1.53-.463 1.59 1.59 0 0 0-.317.1 1.673 1.673 0 0 0-.293.156 1.645 1.645 0 0 0-.468.468 1.684 1.684 0 0 0-.156.293 1.711 1.711 0 0 0-.1.317 1.628 1.628 0 0 0 0 .661 1.769 1.769 0 0 0 .105.317z",
    transform: "translate(-204.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    d: "M192.228 27.929a1.7 1.7 0 0 0 2.4-2.4l-2.482-2.482a1.7 1.7 0 0 0-2.4 2.4z",
    transform: "translate(-157.158 -18.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    d: "M289.321 27.959a1.69 1.69 0 0 0 1.2-.5l2.564-2.564a1.7 1.7 0 1 0-2.4-2.4l-2.564 2.564a1.7 1.7 0 0 0 1.2 2.895z",
    transform: "translate(-238.852 -18.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    d: "M246.027 494.639a1.648 1.648 0 0 0 .468.468 1.674 1.674 0 0 0 .293.156 1.59 1.59 0 0 0 .317.1 1.671 1.671 0 0 0 .331.034 1.708 1.708 0 0 0 1.2-.5 1.625 1.625 0 0 0 .21-.258 1.676 1.676 0 0 0 .156-.293 1.592 1.592 0 0 0 .1-.317 1.629 1.629 0 0 0 0-.661 1.592 1.592 0 0 0-.1-.317 1.675 1.675 0 0 0-.156-.293 1.623 1.623 0 0 0-.21-.258 1.707 1.707 0 0 0-1.53-.463 1.584 1.584 0 0 0-.317.1 1.674 1.674 0 0 0-.293.156 1.648 1.648 0 0 0-.468.468 1.672 1.672 0 0 0-.156.293 1.593 1.593 0 0 0-.1.317 1.637 1.637 0 0 0 0 .661 1.593 1.593 0 0 0 .1.317 1.675 1.675 0 0 0 .155.29z",
    transform: "translate(-204.069 -408.57)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/PEOPLE.6a38559144e4aa0137715baeac28c1cc.svg";
export { ForwardRef as ReactComponent };